/* ============================================================================
   camados.js — das Einblenden beim Scrollen.

   Horizon bringt Seitenuebergaenge mit (View Transitions), aber nichts, was
   Abschnitte beim Hereinscrollen einblendet. Genau das macht bei Apple viel
   her: Der Inhalt ist nicht einfach da, er kommt an.

   ── ZWEI DINGE, DIE HIER NICHT FEHLEN DUERFEN ──────────────────────────────

   1. DIE NOTBREMSE. Nach vier Sekunden wird ALLES sichtbar geschaltet, egal
      was der Beobachter gemeldet hat. Wenn er aus irgendeinem Grund nicht
      ausloest — ein Fehler weiter oben, eine Eigenart im Browser, eine Seite,
      die waehrend des Ladens umspringt —, bleibt sonst die halbe Seite
      unsichtbar. Das faellt beim Entwickeln nie auf, weil es nur unter
      schlechten Bedingungen passiert, und trifft dann genau die Besucher mit
      den schlechten Bedingungen.

      Anders gesagt: Ein Effekt, der Inhalt VERSTECKT, muss einen Weg haben,
      ihn auch ohne sich selbst wieder herzugeben.

   2. `prefers-reduced-motion`. Wer Bewegung abgestellt hat, bekommt alles
      sofort und ohne Uebergang. Das ist keine Feinheit — fuer Menschen mit
      vestibulaeren Beschwerden ist scrollgebundene Bewegung ein echtes
      Problem.

   Die Elemente starten NICHT im CSS unsichtbar, sondern werden erst von hier
   aus markiert. Ohne Javascript bleibt die Seite damit vollstaendig lesbar —
   es gibt keinen Zustand, in dem Inhalt hinter einem Skript verschwindet, das
   nicht laeuft.
   ========================================================================== */

(function () {
  'use strict';

  var SANFT = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (SANFT.matches) return;

  /* Was eingeblendet wird: die Bausteine der ersten Ebene in jedem Abschnitt.
     Nicht der Abschnitt selbst — dann bewegte sich die ganze Flaeche samt
     Hintergrund, und das wirkt wie ein Ruckeln, nicht wie ein Auftritt. */
  var AUSWAHL = '.shopify-section .section > * > .spacing-style > *';

  function start() {
    var kandidaten = Array.prototype.slice.call(document.querySelectorAll(AUSWAHL));
    if (!kandidaten.length || !('IntersectionObserver' in window)) return;

    /* Der erste Bildschirm wird NICHT eingeblendet. Was beim Laden schon zu
       sehen ist, darf nicht erst erscheinen — sonst wartet der Besucher auf
       eine Seite, die schon da war. */
    var ersteHoehe = window.innerHeight;

    kandidaten.forEach(function (el) {
      if (el.getBoundingClientRect().top < ersteHoehe * 0.9) return;
      el.classList.add('camados-kommt');
    });

    var zuTun = document.querySelectorAll('.camados-kommt');
    if (!zuTun.length) return;

    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('camados-da');
        beobachter.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    /* Die Staffelung sitzt auf den GESCHWISTERN, nicht auf der Reihenfolge im
       Dokument: Drei Karten nebeneinander sollen nacheinander kommen, zwei
       Abschnitte untereinander nicht. */
    Array.prototype.forEach.call(zuTun, function (el) {
      var geschwister = Array.prototype.slice.call(el.parentElement.children);
      var i = geschwister.indexOf(el);
      el.style.setProperty('--camados-verzug', Math.min(i, 5) * 60 + 'ms');
      beobachter.observe(el);
    });

    /* ⚠️ Die Notbremse. Siehe Kopfkommentar. */
    window.setTimeout(function () {
      document.querySelectorAll('.camados-kommt:not(.camados-da)').forEach(function (el) {
        el.classList.add('camados-da');
      });
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  /* Horizon wechselt Seiten per View Transitions — dabei laeuft kein neues
     DOMContentLoaded. Ohne das hier bliebe das Einblenden nach dem ersten
     Seitenwechsel aus. */
  document.addEventListener('shopify:section:load', start);
  window.addEventListener('pageshow', function (e) { if (e.persisted) start(); });
})();

/* ============================================================================
   Das Laufband zieht das neueste Update selbst nach.

   Lars (23.09.2026): Das Laufband soll von allein auf dem neuesten Stand der
   Firmware bleiben — aber ABBILD und UPDATE nicht durcheinanderwerfen. Deshalb
   stehen dort zwei Meldungen (werkzeug/laufband-bauen.py), und dieses Stück
   fasst NUR die Update-Meldung an. Es erkennt sie an ihrem Ziel /pages/news;
   die Abbild-Meldung (Ziel /pages/software) bleibt, wie sie gebaut wurde.

   Quelle ist dieselbe Function wie für die News-Seite (firmware-news), und
   gezählt wird nur Firmware für den Raspberry Pi 4 (hw_type pi4) — die für den
   VIM3L ist eine eigene Firmware und gehört nicht in diese Zeile.

   ⚠️ Eingebacken steht immer ein gültiger Stand. Ohne Netz, bei einem Fehler
   oder ohne JavaScript bleibt er stehen. Ersetzt wird nur durch eine NEUERE
   Version, nie durch eine ältere: Eine veraltete Antwort darf das Laufband
   nicht zurückdrehen. Gefragt wird höchstens einmal pro Stunde je Besucher.
   ========================================================================== */
(function () {
  'use strict';

  var WOLKE = 'https://jbyjsanbwzmvesfqocfj.supabase.co';
  // Derselbe öffentliche Lese-Schlüssel wie in camados-news.js — kein Geheimnis.
  var ANON =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpieWpzYW5id3ptdmVzZnFvY2ZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEwMzgzNjgsImV4cCI6MjA5NjYxNDM2OH0.cXYYrMnAWfv-tEb7FZH5Y8g0BOJ-e4WyqiD2ahpvtb0';
  var MERKER = 'camados-laufband-pi4';
  var FRIST = 60 * 60 * 1000;
  var VERSION = /\d+\.\d+\.\d+/;

  function neuerAls(a, b) {
    var x = a.split('.'), y = b.split('.');
    for (var i = 0; i < 3; i++) {
      var d = (parseInt(x[i], 10) || 0) - (parseInt(y[i], 10) || 0);
      if (d) return d > 0;
    }
    return false;
  }

  function updateMeldungen() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.announcement-bar__slide'),
      function (s) {
        var a = s.querySelector('a.announcement-bar__link');
        return a && /\/pages\/news\/?$/.test(a.getAttribute('href') || '');
      });
  }

  function einsetzen(version) {
    updateMeldungen().forEach(function (s) {
      var p = s.querySelector('.announcement-bar__text');
      var alt = p && (p.textContent.match(VERSION) || [])[0];
      if (!alt || !neuerAls(version, alt)) return;
      // Alle Textstellen der Meldung, auch die für Vorleseprogramme im Link.
      var weg = document.createTreeWalker(s, NodeFilter.SHOW_TEXT);
      for (var n = weg.nextNode(); n; n = weg.nextNode()) {
        if (n.nodeValue.indexOf(alt) !== -1) n.nodeValue = n.nodeValue.split(alt).join(version);
      }
    });
  }

  function gemerkt() {
    try {
      var m = JSON.parse(window.localStorage.getItem(MERKER) || 'null');
      if (m && VERSION.test(m.v) && Date.now() - m.t < FRIST) return m.v;
    } catch (e) { /* ohne Speicher wird eben gefragt */ }
    return null;
  }

  function merken(v) {
    try { window.localStorage.setItem(MERKER, JSON.stringify({ v: v, t: Date.now() })); } catch (e) {}
  }

  function abgleichen() {
    if (!updateMeldungen().length) return;
    var v = gemerkt();
    if (v) { einsetzen(v); return; }
    if (!window.fetch) return;
    fetch(WOLKE + '/functions/v1/firmware-news', {
      method: 'POST',
      headers: { 'apikey': ANON, 'Authorization': 'Bearer ' + ANON,
                 'Content-Type': 'application/json' },
      body: JSON.stringify({ hw_type: 'pi4', channel: 'stable', limit: 5 })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var neueste = null;
        ((d && d.eintraege) || []).forEach(function (e) {
          if (e.hw_type !== 'pi4' || !VERSION.test(e.version || '')) return;
          if (!neueste || neuerAls(e.version, neueste)) neueste = e.version;
        });
        if (!neueste) return;
        merken(neueste);
        einsetzen(neueste);
      })
      .catch(function () { /* still — der eingebackene Stand steht schon da */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', abgleichen, { once: true });
  } else {
    abgleichen();
  }
})();
